document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('#mobile-nav');
  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(open));
    menu.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
    mobileNav.hidden = !open;
  });
  mobileNav?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
    mobileNav.hidden = true;
    menu?.setAttribute('aria-expanded', 'false');
  }));
  const searchButton = document.querySelector('[data-search-toggle]');
  const search = document.querySelector('#header-search');
  searchButton?.addEventListener('click', () => {
    const open = searchButton.getAttribute('aria-expanded') !== 'true';
    searchButton.setAttribute('aria-expanded', String(open));
    search.hidden = !open;
    if (open) document.querySelector('#header-search-input')?.focus();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (mobileNav) mobileNav.hidden = true;
    if (search) search.hidden = true;
    menu?.setAttribute('aria-expanded', 'false');
    searchButton?.setAttribute('aria-expanded', 'false');
  });
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.08 });
    document.querySelectorAll('.difference-item, .brand-story, .section-heading').forEach(el => {
      el.classList.add('reveal'); observer.observe(el);
    });
  }
});
